
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService } from '@umanforge/common';
import { GlobalService } from 'services/global.service';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';
import { API } from 'constants/api.constant';
import { DataExportFilters } from 'interfaces/types.interface';
import { EventExported } from 'interfaces/exportData.interface';

export class DataExportService {

  static getDataExport = (
    filters: DataExportFilters,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Blob | null> => {

    return new Promise( async resolve => {
      AXIOS.post( `${API.DATAEXPORT}`, filters, { ...await CommonGlobalService.getHeaderRequest( token ), responseType: 'blob' } )
        .then( ( response: AxiosResponse<Blob> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          const blob = new Blob( [ response.data ], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          } );

          if ( response.status != 204 ) {
            const url = window.URL.createObjectURL( blob );
            const a = document.createElement( 'a' );
            a.href = url;
            a.download = 'FM_TABLE_DATA.xlsx';
            document.body.appendChild( a );
            a.click();
            document.body.removeChild( a );
          } else {
            resolve( null );
            return;
          }

          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  };

  static getDataExportAsJSON = (
    filters: DataExportFilters,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ total: number, datas: EventExported[] }> => {

    return new Promise( async resolve => {
      AXIOS.post( `${API.DATAEXPORT}/json`, filters, { ...await CommonGlobalService.getHeaderRequest( token ) } )
        .then( ( response: AxiosResponse<Record<string, unknown>> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );

          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }

          resolve( response.data as { total: number, datas: EventExported[] } );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( { total: 0, datas: [] } );
        } );
    } );
  };



}
